import React from "react";
import OnboardingButton from "../../components/OnboardingComponents/OnboardingButton";

interface HeaderSectionProps {
  masterUser?: {
    name?: string;
  } | null;
  onShowLogoutModal: (show: boolean) => void;
}

export const HeaderSection = ({ masterUser, onShowLogoutModal }: HeaderSectionProps) => (
  <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
    <div>
      <h1 className="font-['Canela_Text',_serif] font-bold text-4xl text-[#030724]">
        Master User
      </h1>
      {masterUser?.name && (
        <p className="mt-2 font-['Proxima_Nova'] text-base text-[#46464D]">
          Signed in as{" "}
          <span className="font-semibold text-[#1A1F3C]">
            {masterUser.name}
          </span>
        </p>
      )}
    </div>
    <div className="w-fit min-w-[140px]">
      <OnboardingButton
        title="LOG OUT"
        variant="filled"
        onClick={() => onShowLogoutModal(true)}
      />
    </div>
  </div>
);